module.exports = __webpack_public_path__ + "img/not-set-follow-up.b3f044f2.png";